"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _exportButton = _interopRequireDefault(require("../../../core/export-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("h3", null, "Lower Tier Year Book Export");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "This export is taken from the competitions once set up for entries. Before running the final export for the lower tier leaflet, please ensure that all lower tiers have been transferred to the entry system");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Only applications for which a competition has been created will be included.");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", null, "If run by system admin then will return all unpublished and published competitions, otherwise will be limited to competitions that the user can \"see\".");
var _ref5 = /*#__PURE__*/_react.default.createElement("p", null, "Uses the data on the entry system, so will pick up changes to competition names made during creation.");
class CalendarExports extends _react.Component {
  render() {
    if (!this.props.userIsCalendarOfficer) return null;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/_react.default.createElement(_exportButton.default, {
      name: "yearbook",
      args: {
        calendarID: this.props.calendarID
      },
      type: "secondary"
    }, "Export Lower Tier Yearbook Data"));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = CalendarExports;